import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import useTranslate from '../../../core/languages/hooks/useTranslate';
import InputField from '../../../ui/components/InputField/InputField';

interface PickUpTimeProps {
    name?: string; // "pickUpTime" (optional, defaults to "pickUpTime")
}

/**
 * Reusable component for pick up time field
 * Only receives the field name (optional)
 */
const PickUpTime: React.FC<PickUpTimeProps> = ({ name = "pickUpTime" }) => {
    const t = useTranslate();
    const { control, formState: { errors } } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => (
                <InputField
                    {...field}
                    label={t("transfers.fields.pickUpTime") || "Pick Up Time"}
                    type="time"
                    helperText={t("transfers.fields.pickUpTimeHelper")}
                    error={(errors as any)[name]?.message}
                />
            )}
        />
    );
};

export default PickUpTime;

